// src/components/common/BannerWithSocialIcons.js

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faXTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import Banner from './Banner';
import SocialIcons from './SocialIcons';
import api from 'services/api'; // Importer votre service API
import styles from './BannerWithSocialIcons.module.css';
import useAccessibility from 'hooks/useAccessibility';
import { useSubSite } from 'contexts/SubSiteContext'; // Import du contexte de sous-site

const iconMap = {
  facebook: faFacebook,
  twitter: faXTwitter,
  instagram: faInstagram,
  linkedin: faLinkedin,
};

const BannerWithSocialIcons = ({ imageUrl, altText = 'Bannière' }) => {
  const accessibilityVariant = useAccessibility();
  const [socialLinks, setSocialLinks] = useState([]);
  const { isSubSite, subSiteSlug } = useSubSite(); // Utilisation du contexte

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        // Modifier l'endpoint en fonction du contexte de sous-site
        const endpoint = isSubSite 
          ? `/general-informations/social-networks/${subSiteSlug}` 
          : '/general-informations/social-networks';

        const response = await api.get(endpoint);
        setSocialLinks(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des réseaux sociaux:', error);
      }
    };

    fetchSocialLinks();
  }, [isSubSite, subSiteSlug]); // Ajouter les dépendances

  return (
    <div className={styles.container}>
      <SocialIcons key={socialLinks.id} />
      <Banner imageUrl={imageUrl} altText={altText} />
    </div>
  );
};

BannerWithSocialIcons.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  altText: PropTypes.string,
};

export default BannerWithSocialIcons;
